const DIOPTRA_PARAGRAPH_BOOKMARK_PREFIX = "_dioptra_p_";

const bookmarkStartsIn = (paragraph: Element): Element[] =>
    Array.from(paragraph.getElementsByTagName("w:bookmarkStart")).filter((start) =>
        (start.getAttribute("w:name") ?? "").startsWith(DIOPTRA_PARAGRAPH_BOOKMARK_PREFIX),
    );

export const dioptraBookmarkNamesIn = (paragraphs: Element[]): Set<string> => {
    const names = new Set<string>();
    for (const paragraph of paragraphs) {
        for (const start of bookmarkStartsIn(paragraph)) {
            names.add(start.getAttribute("w:name")!);
        }
    }
    return names;
};

const highestBookmarkId = (doc: Document): number => {
    let highest = -1;
    for (const tagName of ["w:bookmarkStart", "w:bookmarkEnd"]) {
        for (const bookmark of Array.from(doc.getElementsByTagName(tagName))) {
            const id = Number(bookmark.getAttribute("w:id"));
            if (Number.isSafeInteger(id) && id > highest) highest = id;
        }
    }
    return highest;
};

const insertStart = (paragraph: Element, start: Element): void => {
    const properties = Array.from(paragraph.childNodes).find(
        (node) => (node as Element).tagName === "w:pPr",
    );
    if (properties?.nextSibling) {
        paragraph.insertBefore(start, properties.nextSibling);
    } else if (properties) {
        paragraph.appendChild(start);
    } else {
        paragraph.insertBefore(start, paragraph.firstChild);
    }
};

export const preserveParagraphBookmarks = (
    oldParagraphs: Element[],
    newParagraphs: Element[],
    doc: Document,
): void => {
    if (newParagraphs.length === 0) return;

    const alreadyPresent = dioptraBookmarkNamesIn(newParagraphs);
    let nextBookmarkId = highestBookmarkId(doc) + 1;

    oldParagraphs.forEach((oldParagraph, index) => {
        const target = newParagraphs[Math.min(index, newParagraphs.length - 1)];

        for (const start of bookmarkStartsIn(oldParagraph)) {
            const name = start.getAttribute("w:name")!;
            if (alreadyPresent.has(name)) continue;
            alreadyPresent.add(name);

            const id = String(nextBookmarkId++);
            const importedStart = doc.importNode(start, true) as Element;
            importedStart.setAttribute("w:id", id);
            insertStart(target, importedStart);

            const end = doc.createElement("w:bookmarkEnd");
            end.setAttribute("w:id", id);
            target.appendChild(end);
        }
    });
};
